import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as OnePage } from './Assets/icons/ONE_PAGE.svg';
import { ReactComponent as FullscreenIcon } from './Assets/icons/FULLSCREEN_ENABLE_Kodansha.svg';
import './KodanshaReader.scss';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { FetchProductAtomV2, ProductErrorAtom } from '../store/ProductStore';
import { useHistory, useParams } from 'react-router-dom';
import { Product } from '../Models/Product';
import loadingSpinner from 'DefaultAssets/LoadingCircle.gif';
import { LoadReader, pagesAtom, ReaderIsFullScreen, UpdateCurrentPage } from '../store/ReaderStore';
import {
    AccessTokenAtom,
    AccountInfoAtom,
    LoginStatus,
    LoginStatusAtom,
    MatureContentWarningAccepted,
} from '../store/AccountStore';
// import Reader from '../Components/Reader/Reader';
import { FetchSeriesAtom } from '../store/SeriesStore';
import KodanshaProgressBar from './KodanshaUIKit/KodanshaProgressBar/KodanshaProgressBar';
import KodanshaColumns from './KodanshaUIKit/KodanshaColumns/KodanshaColumns';
import KodanshaSubmit from './KodanshaUIKit/KodanshaSubmit/KodanshaSubmit';
import { ReactComponent as MenuArrow } from './Assets/icons/MenuArrow.svg';
import SliderArrow from './Assets/icons/SliderArrow';
import Reader from './Reader/Reader';
import Fullscreen from 'react-full-screen';
import { MatureContentVisible } from '../store/OverlayStore';
import MatureContent from './MatureContent/MatureContent';
import apiClient from '../API/InkyAPI';
import { FetchMyBooksAtom, IsMyBooksFetched } from '../store/MyBooksStore';
import { ReaderEndCard } from './KodanshaReader/ReaderEndCard';
import { ReaderStartCard, ReaderStartCardType } from './KodanshaReader/ReaderStartCard';
import { VariantType } from '../Models/CartItem';
import { useWindowSize } from './Hooks/useWindowSize';
import ReactGA from 'react-ga4';
import ChapterVolumeHeader from './KodanshaReader/ChapterVolumeHeader';
import classnames from 'classnames';
import { AnalyticsIdAtom, AnalyticsUserProxyAtom } from '../store/AnalyticsStore';
import AnalyticsReaderEvent from '../Models/Analytics/AnalyticsReaderEvent';
import { Helmet } from 'react-helmet';
import products from '../Components/Dashboard/Products';
import { readerReadableUrlOrDefault } from '../utils/utils';

interface KodanshaReaderParams {
    pid: string;
}

export function KodanshaReader(): JSX.Element {
    const history = useHistory();
    const { pid } = useParams<KodanshaReaderParams>();
    // Get product information
    const [productStore, fetchProduct] = useAtom(FetchProductAtomV2(parseInt(pid)));


    useEffect(() => {
        fetchProduct(parseInt(pid)).then(result => {
            if (result !== false) {
                history.replace(readerReadableUrlOrDefault(result));
            }
        });

    }, [pid]);

    return <KodanshaReaderComponent product={productStore} isZoomEnabled={true} isEmbed={false} />;
}

interface KodanshaReadableReaderParams {
    seriesParam: string;
    volumeParam: string;
    chapterParam?: string;
}


export function KodanshaReadableReader(): JSX.Element {

    const history = useHistory();
    const [product, setProduct] = useState<Product|false>()
    const { seriesParam, volumeParam, chapterParam} = useParams<KodanshaReadableReaderParams>();
    const setError = useSetAtom(ProductErrorAtom)

    async function getProduct(){

        console.log("get product",seriesParam,volumeParam,chapterParam);

        const result:false|Product = await apiClient.getProductBySeriesUrlAndVolume(seriesParam,decodeURI(volumeParam),chapterParam!== undefined? decodeURI(chapterParam):undefined,null).catch( () => {
            setError("Product not found")
            return false});
        setProduct(result);
        if (result!==false) {
            setError(false);
            history.replace(readerReadableUrlOrDefault(result));
        }
        console.log("set product",result)
    }

    useEffect(() => {
        getProduct();

    }, [seriesParam,volumeParam,chapterParam]);


    if(!product|| product?.id===undefined){
        return <KodanshaReaderComponent product={false} isZoomEnabled={true} isEmbed={false}/>
    }

    return <KodanshaReaderComponent product={product} isZoomEnabled={true} isEmbed={false}/>

}

interface KodanshaReaderComponentProps {
    product: Product|false;
    isEmbed: boolean;
    isZoomEnabled: boolean;
}

export function KodanshaReaderComponent({ product, isZoomEnabled, isEmbed }: KodanshaReaderComponentProps): JSX.Element {
    const history = useHistory<{returnPath: string}>();
    const [matureContentVisible, setShowMatureContentWarning] = useAtom(MatureContentVisible);
    const [matureContentWarningAccepted, SetMatureContentWarningAccepted] = useAtom(MatureContentWarningAccepted);

    const [AccessToken] = useAtom(AccessTokenAtom);

    const [seriesArray, fetchSeries] = useAtom(FetchSeriesAtom);
    const [productsInSeries, setProductsInSeries] = useState<Product[]>(null);
    const isPointerOnMenu = useRef(false);
    const isMouseDragged = useRef(-1);
    const timeout = useRef(null);

    const [isOverlay, setIsOverlay] = useState(false);
    const [isFullScreenEnabled, setIsFullScreenEnabled] = useAtom(ReaderIsFullScreen);
    const [chaptersModal, setChaptersModal] = useState(false);
    const [currentPage, setCurrentPage] = useAtom(UpdateCurrentPage);

    const [myBooks, fetchMyBooks] = useAtom(FetchMyBooksAtom);
    const MyBooksIsFetched = useAtomValue(IsMyBooksFetched);
    const [currentProductIsOwnedByUser, setCurrentProductIsOwnedByUser] = useState(true);
    const [nextProductIsOwnedByUser, setNextProductIsOwnedByUser] = useState(false);

    const [isDoublePage, setIsDoublePage] = useState(true);

    const [, loadReader] = useAtom(LoadReader);
    const [pages] = useAtom(pagesAtom);

    const [isLoading, setIsLoading] = useState(true);
    const [showStartCard, setShowStartCard] = useState(false);

    const [showFullScreenButton, setShowFullscreenButton] = useState(false);

    const clientDimensions = useWindowSize();


    // Upsell datapoints
    const [nextProductInSeries, setNextProductInSeries] = useState<Product>(null);


    // StartCard States
    const [loginStatus] = useAtom(LoginStatusAtom);
    const [accountInfo] = useAtom(AccountInfoAtom);
    const [freeForRegistered, setFreeForRegistered] = useState(false);
    const [startCardType, setStartCardType] = useState<ReaderStartCardType>(null);
    const [productError] = useAtom(ProductErrorAtom);

    const [isEndCardVisible, setIsEndCardVisible] = useState(false);

    //Used for Analytics
    const [sessionId] = useAtom(AnalyticsIdAtom);
    const [analyticsUserProxy] = useAtom(AnalyticsUserProxyAtom);

    function sendReaderEvent(eventName: string, product: Product, pageNumber: number){
        if(!product) return;

        let eventTag = "";

        if(loginStatus === "LoggedIn")
        {
            //This is just temporary for AX - this if statement can be removed after the event.
            if(accountInfo && accountInfo.email === "levi@kodanshausa.com" || "varghese@kodanshausa.com" ||
                "hawk@kodanshausa.com" || "birdhead@kodanshausa.com" || "aoneko@kodanshausa.com" ||
                "liebe@kodanshausa.com" || "ssgirls@kodanshausa.com" || "kanata@kodanshausa.com")
            {
                eventTag = "AX";
            }
        }

        const readerEvent = new AnalyticsReaderEvent(sessionId.toString(), eventName, window.location.pathname,
            "", product.id, product.name, product.series.id, product.series.title, product.subCategory,
            product.tags, product.variants[0]?.priceType ?? "Unknown", product.variants[0]?.price?.toFormat() ?? "Unknown", product.variants[0]?.isOnSale ?? false,
            product.creators, pageNumber, eventTag, analyticsUserProxy);

        apiClient.sendReaderEvent(accountInfo,readerEvent).then(response => {
            console.log(response);
        }).catch(e => {
            console.error(e);
        });
    }

    useEffect(() => {
        setIsFullScreenEnabled(false);
        if(document.fullscreenEnabled || document.webkitFullscreenEnabled){
            setShowFullscreenButton(true);
        }
    }, []);


    useEffect(() => {
        console.log("[KodanshaReader] My Books", myBooks);
    }, [myBooks]);

    useEffect(() => {
        console.log('Current page changed!', currentPage);
        if (!product) return;
        sendReaderEvent("READ", product, currentPage);
    }, [currentPage]);

    // When product is available, load series
    useEffect(() => {
        if (!product) return;
        console.log('Fetching series with it', product.readable.seriesId);
        fetchSeries(product.readable.seriesId).then();

        console.debug("[KodanshaReader] Product Data", product);


        // Check the age rating
        const ageRatingNumber = parseInt(product.ageRating);
        console.debug("[KodanshaReader] Age rating number is", ageRatingNumber);
        setShowMatureContentWarning(ageRatingNumber >= 18);

        console.debug("[KodanshaReader] Fetch other products in series");


        apiClient.getProductsForSeries(product.series.id, null).then(products => {
            setProductsInSeries(products);
        });


        // Check wetever this product is free when registered or not.
        setFreeForRegistered(product.variants.find(x => x.type == VariantType.Digital)?.priceType == "FreeForRegistered");


    }, [product]);

    useEffect(() => {
        console.debug("[KodanshaReader] Products in series?", productsInSeries);
        if(!productsInSeries) return;
        if(!product) return;
        console.debug("[KodanshaReader] Products in series", productsInSeries);


        // If current product is a chapter, check if there is another chapter next
        console.debug("[NEXT] product is", product);
        if(product.subCategory == "Chapter"){

            // We need to find the volume for this chapter in the series-list:
            const volumeForChapter = productsInSeries.find(x => x.volumeNumber == product.volumeNumber);
            console.debug("[NEXT] Volume for Chapter is", volumeForChapter);

            if(volumeForChapter){
                const nextChapter = volumeForChapter.chapters?.find(x => x.chapterNumber == product.chapterNumber + 1);
                // If we have a next chapter, show that, if not, lets continue looking
                if(nextChapter){
                    console.debug("[NEXT] Found next chapter");
                    setNextProductInSeries(nextChapter);
                    return;
                }
            }

        }

        // Could not find a next chapter, looking for next volume
        const nextVolume = productsInSeries.find(x => x.volumeNumber == product.volumeNumber + 1);
        if(nextVolume){
            setNextProductInSeries(nextVolume);
        }

    }, [productsInSeries]);

    useEffect(() => {
        clearTimeout(timeout.current);
        if (isOverlay && !isEndCardVisible) { // Only start timer if end-card is not visible
            //timeout.current = setTimeout(() => {
            //    if(isEndCardVisible) return; // Don't execute this timer if its already started and reader is visible
            //    !isPointerOnMenu.current && setIsOverlay(false);
            //}, 3500);
        }

        if(!isOverlay && chaptersModal){
            setChaptersModal(false);
        }

    }, [isOverlay, isEndCardVisible]);

    useEffect(() => {
        isPointerOnMenu.current = false;
        setIsOverlay(false);
        clearTimeout(timeout.current);
    }, [isFullScreenEnabled]);

    useEffect(() => {
        console.debug("[KodanshaReader] Loading", isLoading);
        console.debug("[KodanshaReader] startCard", showStartCard);
    }, [isLoading, showStartCard]);

    const [gaSent, setGaSent] = useState(false);
    // Google Analytics on mount
    useEffect(() => {
        if(!product) return; // We need the product for this
        if(!product.name) return; // We need the product name specificly
        if(!gaSent){
            ReactGA.send({ hitType: "pageview", page: window.location.href, title: 'Reader | ' + product.name });
            setGaSent(true);
        }
    }, [product]);

    // Decide whetever to show a start-card or the reader after loading is done.
    useEffect(() => {


        console.log("PRODUCT ERROR", productError);

        if(productError){
            console.debug('Product does not exist', productError);
            setStartCardType(ReaderStartCardType.NotFound);
            setShowStartCard(true);
            return;
        }

        if(!seriesArray) return;
        if(!product) return;
        console.debug("ACCOUNT INFO",accountInfo)
        if(accountInfo?.roles?.includes("admin") || accountInfo?.roles?.includes("staff")){
            // Admins and staff never see start card
            setShowStartCard(false);
            setIsLoading(false);
            return;
        }

        const variant = product.variants?.find(x => x.type = VariantType.Digital);

        console.log("[KodanshaReader] Checking if we should show a start-card");
        // If user is logged out, user should only be able to access free comics
        if(loginStatus == "LoggedOut"){
            console.debug('[KodanshaReader] User is not logged in.');

            if(variant.priceType == 'Paid'){
                console.debug('[KodanshaReader] Product is available for purchase with account');
                setStartCardType(ReaderStartCardType.AvailableForPurchaseWithAccount);
                setShowStartCard(true);
                return;
            }
            console.debug('[KodanshaReader] Product is not paid');

            if(variant.priceType == 'FreeForRegistered'){
                console.debug('[KodanshaReader] Product is available for free with account');
                setStartCardType(ReaderStartCardType.AvailableForFreeWithAccount);
                console.debug('[KDRED]');
                setShowStartCard(true);
                return;
            }

            console.debug('[KodanshaReader] Product is not FreeForRegistered');

            if(variant.priceType == 'FreeToReadForRegisteredAndPurchaseble'){
                console.debug('[KodanshaReader] Product is available for free with account and available to purchase');
                setStartCardType(ReaderStartCardType.AvailableForFreeWithAccount)
                setShowStartCard(true);
                return;
            }

            console.debug('[KodanshaReader] Product is not FreeToReadForRegisteredAndPurchaseble');
            console.warn('[KodanshaReader] Product is of unknown pricetype.');


            setShowStartCard(false);
            setIsLoading(false);
            return;

        }

        // If user is logged in
        if(loginStatus == "LoggedIn"){
            console.debug('[KodanshaReader] User is logged in', loginStatus);


            if(variant.priceType == 'Paid'){
                console.debug('[KodanshaReader] Product has a price');

                // Check that books is actually fetched first.
                if(MyBooksIsFetched){
                    if(myBooks.length == 0 || !myBooks.find(x => x.id == product.id)){
                        console.log("[KodanshaReader] User does not own this book.", myBooks.find(x => x.id == product.id));
                        setStartCardType(ReaderStartCardType.AvailableForPurchase);
                        setShowStartCard(true);
                        return;
                    }
                } else {
                    console.log("[KodanshaReader] MyBooks is not fetched yet.");
                }

            }


            // We default to that the user has access.
            setShowStartCard(false);
            setIsLoading(false);
            return;
        }


    }, [product, seriesArray, myBooks, freeForRegistered, loginStatus, productError, accountInfo,MyBooksIsFetched]);


    // Check if user owns the next book in series
    useEffect(() => {
        if(!myBooks) return;
        if(!nextProductInSeries) return;

        // Check next book in series
        if(myBooks.length > 0 && myBooks.find(x => x.id == nextProductInSeries.id)){
            console.log("[KodanshaReader] User owns the NEXT book in the series.");
            setNextProductIsOwnedByUser(true);
        } else {
            console.log("[KodanshaReader] User does NOT own the NEXT book in the series.")
            setNextProductIsOwnedByUser(false);
        }
    }, [myBooks, nextProductInSeries]);

    useEffect(() => {
        const aspectRatio = clientDimensions.height / clientDimensions.width;
        // If height is larger than the width, set to single mode
        if(aspectRatio > 0.7){
            setIsDoublePage(false);
        }

        const vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);

    }, [clientDimensions]);

    // Load My Books when we have correct loginstatus
    useEffect(() => {
        if(loginStatus == "LoggedIn"){
            fetchMyBooks().then();
        }
    }, [loginStatus]);

    useEffect(() => {

        // Is this part of spec?
        const onKeyPress = (e) => {
            if (e.keyCode === 113) {
                setIsFullScreenEnabled(false);
            }
        };
        window.addEventListener('keypress', onKeyPress);

        // On Dismount
        return () => window.removeEventListener('keypress', onKeyPress);
    }, []);

    const activateTimerForMenu = () => {
        clearTimeout(timeout.current);
        //timeout.current = setTimeout(() => {
        //    !isPointerOnMenu.current && setIsOverlay(false);
        //}, 3500);
    };

    function closeReader(){
        if(history.location.state?.returnPath){
            history.push(history.location.state["returnPath"]);
            return;
        }
        history.push('/');
    }

    function ShowOverlay(): JSX.Element {
        return (<div className={'menu-overlay'}>

            <div onMouseOver={() => {
                isPointerOnMenu.current = true;
            }}
                 onMouseDown={e => e.stopPropagation()}
                 onMouseUp={e => e.stopPropagation()}
                 onMouseLeave={() => {
                     activateTimerForMenu();
                     isPointerOnMenu.current = false;
                 }} className={'top-bar'}>
                <div className='top-bar-close-wrapper' onClick={() => closeReader()}>
                    <div className='back-icon-wrapper'>
                        <SliderArrow />
                    </div>
                    <div className='back-text-wrapper'>
                        <span className='back-text'>Close reader</span>
                    </div>
                </div>
            </div>

            <div onMouseOver={() => {
                isPointerOnMenu.current = true;
            }}
                 onMouseDown={e => e.stopPropagation()}
                 onMouseUp={e => e.stopPropagation()}
                 onMouseLeave={() => {
                     activateTimerForMenu();
                     isPointerOnMenu.current = false;
                 }} className={'bottom-bar'}>
                <div className='bottom-bar-inner-wrapper'>
                    <div className='title-bar'>
                        {product !== false && (<><span className='title'>{product?.series?.title}</span>
                            <div className='page-wrapper'>
                                <span className='page'>{currentPage + 1} / {product.readable.pageCount}</span>
                            </div>
                        </>)}
                    </div>


                    <div className='action-wrapper'>
                        <div className='select-wrapper' onClick={(e): void => {
                            e.stopPropagation();
                            setChaptersModal(!chaptersModal);
                        }}>
                            <div className='volume-wrapper'>
                                {product !== false && (
                                    <>
                                        <div className='volume-text-wrapper'>
                                            {product.subCategory == 'Chapter' && (<>
                                                <span className='volume-text'>Volume {product.volumeNumber}</span>
                                                <span
                                                    className='chapter-text'> {product.relativeName ?? 'Chapter ' + product.chapterNumber}</span>
                                            </>)}
                                            {product.subCategory == 'Volume' && (<>
                                                <span
                                                    className='volume-text-standalone'>Volume {product.volumeNumber}</span>
                                            </>)}
                                        </div>
                                    </>
                                )}

                                <MenuArrow className='select-svg' width={20} height={20} fill={'white'} />
                            </div>
                        </div>


                        <div className='icons-wrapper'>

                            <div className='left-icons-wrapper on-page-container' onClick={(e => {
                                setIsDoublePage(false);
                            })}>
                                <div className='direction-icons-wrapper'>
                                    <OnePage width='55' height='70' />
                                </div>

                                <span className='direction-text'>1 page</span>
                            </div>

                            <div className='left-icons-wrapper two-pages-container' onClick={(e => {
                                setIsDoublePage(true);
                            })}>
                                <div className='make-two-pages'>
                                    <OnePage width='35' height='70' className='two-pages-icon' />
                                    <OnePage width='35' height='70' className='two-pages-icon' />
                                </div>

                                <span className='direction-text'>2 pages</span>
                            </div>

                            {/*<div className='left-icons-wrapper position-icons'>
                                <div className='direction-icons-wrapper'>
                                    <BackIcon width='55' height='70' className='left' />
                                    <BackIcon width='55' height='70' className='right' />
                                </div>

                                <span className='direction-text'>Horizontal</span>
                            </div>*/}

                            {showFullScreenButton && (<div onClick={(e) => {
                                e.stopPropagation();
                                setIsFullScreenEnabled(isFullScreenEnabled => !isFullScreenEnabled);
                            }} className='left-icons-wrapper right-icons-wrapper'>
                                <FullscreenIcon width='70' height='70' className='fullscreen-icon right' />
                                {/*<img src={FullscreenIcon} className='fullscreen-icon right' />*/}
                                <span className='direction-text'>Fullscreen</span>
                            </div>)}


                        </div>
                    </div>
                </div>

            </div>

        </div>);
    }




    const getReadingPercentageForChapter = (product: Product, volumeId: number): number => {
        if(!myBooks) return 0;
        if(myBooks.length < 0) return 0;

        console.debug("Chapter data", product);
        // Product could be either a chapter or volume, so lets check
        console.debug("Current Chapter", product.id);

        const ownedChapter = myBooks.find(x => x.id == product.id);

        // If user owns the chapter
        if(ownedChapter){
            return (ownedChapter.readingProgress / ownedChapter.pageCount) * 100;
        }

        console.debug("Does not own chapter. check volume", product.volumeId);

        const ownedVolume = myBooks.find(x => x.id == volumeId);

        if(ownedVolume){
            console.debug("User owns volume for iterated chapter");
            const volumeReadingProgress = Math.min((ownedVolume.readingProgress / product.readable.pageCount) * 100, 100);
            console.debug("Reading Progress for chapter:", volumeReadingProgress);
            return volumeReadingProgress;
        }

        console.debug("Does not own volume. return 0", myBooks)
        return 0;

    };

    const ChaptersItem = (chapter: Product, volumeId: number, chapterNumber: number, relativeName: string, date: string): JSX.Element => {
        console.debug("Loading Chapter Items");
        //TODO: READER uses readable url - done?
        function onChapterClick(e): void{
            e.preventDefault();

            if(chapter.variants.find(x => x.type == "Digital").priceType != "NotForSale"){
                window.location.href = readerReadableUrlOrDefault(chapter);
            }
        }

        const isUnavailable = (chapter.variants.find(x => x.type == "Digital").priceType == "NotForSale");

        const readingProgressInPercentage = getReadingPercentageForChapter(chapter, volumeId);

        const isCurrent = (product!== false)&&chapter.id == product.id;

        const classes = classnames({
            'reader-chapter-item-wrapper': true,
            'unavailable': isUnavailable,
            'selected': isCurrent
        });

        let label;

        if(chapter.variants[0].priceType == "Free") label = "Free";

        if(chapter.variants[0].priceType == "FreeForRegistered"){
            if(loginStatus != "LoggedIn"){
                label = "Free on sign up";
            }else {
                label = "Free";
            }
        }


        return <div key={chapter.id} className={classes} onClick={(e) => {onChapterClick(e);} }>
            <div className={'chapter-title'}>
                <span className='chapter-name'>{relativeName}</span>
                <span className={'chapter-label'}>{label}</span>
            </div>
            <span className='chapter-date'>{/*date*/}</span>
            <div className='chapter-item-progress-wrapper'>
                <KodanshaProgressBar fill={readingProgressInPercentage} />
            </div>
        </div>;
    };


    const ShowChaptersModal = (): JSX.Element => {
        return <div
            onWheel={(e) => {
                e.stopPropagation();
            }}
            onClick={(e) => {
                const target = e.target as Element;
                //console.debug("Chapternagclick", target.classList.contains("reader-chapters-container"));
                if(target.classList.contains("reader-chapters-container") && chaptersModal){
                    e.stopPropagation();
                    setChaptersModal(false);
                }
            }}
            className='reader-chapters-container'>

            {product !== false && (<>
                <div className='reader-chapters-modal'>

                    <div className='reader-chapter-header' onClick={(e) => {
                        e.preventDefault();
                        history.push('/series/' + product.series.id);
                    }
                    }>
                        {/*<div className='reader-chapters-poster-wrapper'>
                         comment out image tag when data is ready
                        <img src={''} alt={''} className='reader-chapters-poster'/>
                    </div>*/}

                        <div className='reader-chapters-info-wrapper'>
                            <span className='reader-chapters-info-text'>{product.series.title}</span>
                            {product.creatorsToString() && (
                                <span className='reader-chapters-info-author'>By {product.creatorsToString().replace(/,/g, ', ')}</span>)}
                        </div>
                    </div>
                    <>
                        {productsInSeries?.map((volume) => {
                            const isOwned = myBooks?.map(x => x.id)?.includes(volume.id);
                            if (volume.subCategory != 'Volume') return; // Only Show products that are volumes
                            if (!volume.variants || volume.variants.length <= 0) return;
                            return (
                                <ChapterVolumeHeader key={volume.id} volume={volume} isOwned={isOwned}
                                                     isSelected={product.id == volume.id} childAsRenderedProps={
                                    volume?.chapters?.filter(x => ['Free', 'FreeForRegistered'].includes(x.variants[0].priceType)).map((chapter) => {
                                        return ChaptersItem(chapter, volume.id, chapter.chapterNumber, chapter.relativeName, '7/7/2022');
                                    })
                                } />
                            );
                        })}
                    </>

                </div>
            </>)}
        </div>;
    };

    const showUnlockModal = (): JSX.Element => {
        return <div onWheel={e => e.stopPropagation()} className='reader-unlock-container'>
            <div className='reader-unlock-modal'>

                <KodanshaColumns
                    Left={
                        <div className='reader-unlock-image-wrapper'>
                            {/* comment it out later when the data available */}
                            {/*<img src={''} alt={''} className='reader-unlock-image' />*/}
                        </div>
                    }

                    Right={
                        <div className='reader-unlock-info-wrapper'>
                            <span className='reader-unlock-info-text'>Product name</span>
                            <span className='reader-unlock-info-chapter'>Chapter 3</span>
                            <span className='reader-unlock-info-limit'>To You, 2,000 Years From Now</span>
                        </div>
                    }
                />

                <div className='reader-unlock-buy-wrapper'>
                    <span className='reader-unlock-buy-text'>Free*</span>
                    <KodanshaSubmit text={'Unlock'} />
                    <span className='reader-unlock-buy-action-required'>*Account creation required.</span>
                </div>

            </div>
        </div>;
    };



    if(showStartCard && startCardType != null ){
        return(<ReaderStartCard
            cardType={startCardType}
            currentProduct={product}
            isOwnedByUser={currentProductIsOwnedByUser}
            onCloseReader={closeReader}
        />);
    }


    // Show when loading
    if (isLoading) {
        return (<div className={'KodanshaReader'}>
            <div className={'loading'}>
                <img src={loadingSpinner} />
            </div>
        </div>);
    }



    return (<div className={'KodanshaReader'}
                 onMouseDown={(e) => {
                     //e.stopPropagation();
                     isMouseDragged.current = e.clientX;
                 }}
                 onMouseUp={(e) => {
                     //e.stopPropagation();
                     if (isMouseDragged.current > e.clientX - 50 && isMouseDragged.current < e.clientX + 50) {
                         // We should only toggle overlay whenever the reader-page or the overlay itself is clicked.
                         const target = e.target as Element;
                         console.log("Click Debug", target.className, target.classList)
                         if(isEndCardVisible) return; // We dont want to toggle endcard if overlay is visible.
                         if (target.classList.contains('reader-page') || target.classList.contains('menu-overlay')) {
                             setIsOverlay(isOverlay => !isOverlay);
                             if(isOverlay && chaptersModal){
                                 setChaptersModal(false);
                             }
                         }
                     }
                 }}
    >
            {!isEmbed && <Helmet>
            {/*Basic SEO Tags*/}
            <title>{(product ===false)?"Kodansha – Inspire Impossible Stories":(`${product.series.title}, Volume ${product.volumeNumber}${(product.subCategory==="Chapter"?`, Chapter ${product.chapterNumber}`:"")}`)}</title>
            {product !== false && <meta name='description' content={product?.description} /> }
            {product !== false && product.subCategory === "Chapter" && (<link rel='canonical'
                      href={'/reader/' + product.series.readableUrl + '/' + "volume-" + product.volumeNumber + '/' + "chapter-" + product.chapterNumber + '/'}/>
            )}
            {product !== false && product.subCategory === "Volume" && (<link rel='canonical'
                                                                              href={'/reader/' + product.series.readableUrl + '/' + "volume-" + product.volumeNumber + '/'}/>
            )}

            {/*OpenGraph*/}

            {product !== false && <meta property='og:title' content={(`${product.series.title}, Volume ${product.volumeNumber}${(product.subCategory==="Chapter"?`, Chapter ${product.chapterNumber}`:"")}`)} />}
            {product !== false && <meta property='og:type' content='Book' />}
            {product !== false && <meta property='og:description' content={product?.description} />}
            {product !== false && <meta property='og:site_name' content='Kodansha' />}
            {product !== false && <meta property='og:locale' content='en-GB' />}
            {product !== false && <meta property='og:image' content={product?.thumbnails[0]?.url} />}

            {/* Twitter (https://developer.twitter.com/en/docs/twitter-for-websites/cards/guides/getting-started) */}
            {product !== false && <meta name='twitter:card' content='summary' />}
            {product !== false && <meta name='twitter:site' content='@KodanshaManga' />}
            {product !== false && <meta name='twitter:title' content={(`${product.series.title}, Volume ${product.volumeNumber}${(product.subCategory==="Chapter"?`, Chapter ${product.chapterNumber}`:"")}`)} />}
            {product !== false && <meta name='twitter:description' content={product?.description} />}
            {product !== false && <meta name='twitter:image:src' content={product.thumbnails[0]?.url} />}
            {product !== false && <meta name='twitter:image:alt' content={'Image from ' + product.series.title + " - " + product.relativeName} />}
            {product !== false && <meta name='twitter:domain' content='Kodansha' />}

        </Helmet>}

        {matureContentVisible && !matureContentWarningAccepted && <MatureContent />}

        {product !==false &&(
            <Fullscreen
                enabled={isFullScreenEnabled}
                onChange={isFull => {
                    !isFull && setIsFullScreenEnabled(false);
                }}
            > <Reader
                comicId={product.id}
                comics={[]}
                isFullScreenEnabled={isFullScreenEnabled}
                isZoomEnabled={isZoomEnabled}
                series={seriesArray[product.readable.seriesId]}
                initialPage={product.readable.readingProgress}
                endCard={(e) => {return (<ReaderEndCard onCloseReader={closeReader} onGoBack={e} nextProduct={nextProductInSeries} isOwnedByUser={nextProductIsOwnedByUser} currentProduct={product}/>)} }
                sendInstrumentationData={(data): void => {
                    //this.props.sendInstrumentationData(data);
                }}
                onFullScreenChange={(): void => {
                    setIsFullScreenEnabled(false);
                }}
                onClose={(): void => {
                    // User wants to close the reader, lets go back in history to last place
                    // console.log('Reader closing. Navigating to ', this.state.onCloseUrl);
                    //this.props.history.push(this.state.onCloseUrl);
                    closeReader();
                }}
                onOpenChapter={(id: number): void => {
                    //const url = '/reader/' + id;
                    //window.location.href = url;
                }}
                onNextChapter={(): void => {
                    //const url = '/reader/' + this.getNextChapterComicId();
                    //window.location.href = url;
                }}
                onPreviousChapter={(): void => {
                    //const url = '/reader/' + this.getPreviousChapterComicId();
                    //window.location.href = url;
                }}
                onEndCardVisible={(isVisible: boolean): void => {
                    setIsEndCardVisible(isVisible);
                    setIsOverlay(isVisible);
                }}
                onSetCurrentPage={(currPage: number): void => {
                    console.log('Page-update from Reader', currPage);
                    console.log('Initial page was', product.readable.readingProgress);
                    if (currPage != product.readable.readingProgress) {
                        console.log('Updating backend');
                        setCurrentPage({ publicationId: product.id, pageNumber: currPage });
                        // We also need to update the product. TODO: Make this workflow better
                        product.readable.readingProgress = currPage;
                    }

                    //const comic = this.getCurrentComic();
                    //if(comic != null){
                    //    comic.currentPage = currPage;
                    //    this.props.onReaderSetCurrentPage(comic);
                    //}
                }}

                reverseReadingMode={(product.downloadable !== null && product.downloadable !== undefined) ? product.downloadable.reverseReadOrder : true}
                doublePage={isDoublePage}
            />
                {isOverlay && <ShowOverlay />}
                {chaptersModal && <ShowChaptersModal />}
            </Fullscreen>
        )}
    </div>);
    //endregion

}
